import { makeStyles, Slider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import { UIText } from '../../components/ui-text/ui-text';
import { useSound } from '../hooks/use-sound';
import { useMusicContext, useMusicVolumeContext, useMusicVolumeDispatch } from './music-context';
import { useSoundContext, useSoundVolumeContext, useSoundVolumeDispatch } from './sound-context';
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        labelCell: {
            paddingLeft: 0,
            paddingRight: spacing(1),
            border: 'none'
        },
        sliderCell: {
            width: '100%',
            border: 'none'
        },
        slider: {
            verticalAlign: 'text-top'
        }
    });
});
export var AudioOptions = function () {
    var classes = useStyles();
    var playSound = useSound();
    var hasMusicContext = !!useMusicContext();
    var musicVolume = useMusicVolumeContext();
    var setMusicVolume = useMusicVolumeDispatch();
    var hasSoundContext = !!useSoundContext();
    var soundVolume = useSoundVolumeContext();
    var setSoundVolume = useSoundVolumeDispatch();
    var volumeLines = [
        {
            name: 'Music',
            hasContext: hasMusicContext,
            volume: musicVolume,
            setVolume: setMusicVolume
        },
        {
            name: 'Sounds',
            hasContext: hasSoundContext,
            volume: soundVolume,
            setVolume: setSoundVolume
        },
    ];
    var previousSoundVolume = React.useRef();
    React.useEffect(function () {
        if (previousSoundVolume.current !== soundVolume) {
            playSound('buttonClick');
        }
        previousSoundVolume.current = soundVolume;
    }, [soundVolume, playSound]);
    return React.createElement(React.Fragment, null,
        React.createElement(UIText, { variant: 'h4' }, "Audio"),
        React.createElement(Table, null,
            React.createElement(TableBody, null, volumeLines.map(function (_a) {
                var name = _a.name, hasContext = _a.hasContext, volume = _a.volume, setVolume = _a.setVolume;
                return (React.createElement(TableRow, { key: name },
                    React.createElement(TableCell, { className: classes.labelCell, size: 'small' },
                        React.createElement(UIText, { variant: 'body1' }, name)),
                    React.createElement(TableCell, { className: classes.sliderCell }, hasContext
                        ? React.createElement(Slider, { className: classes.slider, min: 0, max: 1, step: 0.1, value: volume, onChange: function (e, value) {
                                if (value === volume) {
                                    return;
                                }
                                setVolume(value);
                            } })
                        : React.createElement(UIText, { variant: 'body2' }, "click anywhere to enable"))));
            }))));
};
